// src/components/Activities/StrategicAlignment.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Activities.css';

const StrategicAlignment = () => {
    return (
        <div className="activity-page">
            {/* Hero Section */}
            <div className="activity-hero" style={{
                backgroundImage: 'linear-gradient(rgba(13, 61, 37, 0.5), rgba(43, 16, 7, 0.5)), url(/images/hero/climate_green_goals.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}>
                <div className="activity-hero-overlay"></div>
                <div className="activity-hero-content" style={{ textShadow: '0 2px 12px rgba(0, 0, 0, 0.8)' }}>
                    <span className="activity-hero-badge">STRATEGIC ALIGNMENT</span>
                    <h1>Strategic Alignment with Global & Regional</h1>
                    <h2>Climate, Infrastructure, & Green Investment Goals</h2>
                    <p>
                        The Africa Infrastructure, Climate Change, and Green Investment Summit (AICIS) 2026
                        in Nigeria is strategically designed to align with the climate change, infrastructure
                        development, and green investment objectives of key international and regional organizations.
                    </p>
                </div>
            </div>

            {/* Content */}
            <div className="activity-container">

                {/* United Nations */}
                <div className="alignment-section">
                    <div className="alignment-logo-wrapper">
                        <img
                            src="/images/logos/UnitedNations.jpg"
                            alt="United Nations Logo"
                            className="alignment-logo"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.parentElement.innerHTML = '<div class="alignment-logo-placeholder">🇺🇳</div>';
                            }}
                        />
                    </div>
                    <div className="alignment-content">
                        <h3>AICIS 2026 AND UNITED NATIONS OBJECTIVES</h3>
                        <p>
                            The United Nations emphasizes global collaboration to combat climate change, promote sustainable infrastructure,
                            and mobilize green investments. AICIS 2026 echoes these priorities by facilitating dialogues and partnerships
                            aimed at accelerating climate-resilient infrastructure projects and enhancing access to climate finance.
                            The summit's focus on innovative financing mechanisms, such as blended finance and climate adaptation bonds,
                            aligns with the UN's advocacy for increased climate finance flows to developing countries, as highlighted
                            during COP29 discussions.
                        </p>
                    </div>
                </div>

                {/* African Union */}
                <div className="alignment-section">
                    <div className="alignment-logo-wrapper">
                        <img
                            src="/images/logos/AfricaUnion.jpg"
                            alt="African Union Logo"
                            className="alignment-logo"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.parentElement.innerHTML = '<div class="alignment-logo-placeholder">🌍</div>';
                            }}
                        />
                    </div>
                    <div className="alignment-content">
                        <h3>AICIS 2026 AND AFRICA UNION OBJECTIVES</h3>
                        <p>
                            The African Union's Agenda 2063 outlines a vision for a prosperous Africa based on inclusive growth and
                            sustainable development. AICIS 2026 contributes to this vision by promoting green investment strategies that
                            leverage Africa's sovereign wealth funds for sustainable projects. By focusing on sectors like renewable energy,
                            smart infrastructure, and sustainable agriculture, the summit supports the AU's goals of environmental
                            sustainability and economic transformation. Furthermore, AICIS 2026's emphasis on digital transformation in
                            driving green initiatives aligns with the AU's commitment to harnessing technology for development.
                        </p>
                    </div>
                </div>

                {/* ECOWAS */}
                <div className="alignment-section">
                    <div className="alignment-logo-wrapper">
                        <img
                            src="/images/logos/Ecowas.jpg"
                            alt="ECOWAS Logo"
                            className="alignment-logo"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.parentElement.innerHTML = '<div class="alignment-logo-placeholder">🏛️</div>';
                            }}
                        />
                    </div>
                    <div className="alignment-content">
                        <h3>AICIS 2026 AND ECOWAS OBJECTIVES</h3>
                        <p>
                            ECOWAS aims to foster economic integration and development among West African countries, with a strong
                            emphasis on infrastructure development and environmental sustainability. AICIS 2026 aligns with ECOWAS
                            objectives by addressing regional challenges such as energy access and climate resilience. The summit's
                            focus on public-private partnerships and innovative financing models aims to unlock investments in critical
                            infrastructure projects across West Africa, supporting ECOWAS's mission to enhance regional connectivity
                            and sustainable development.
                        </p>
                    </div>
                </div>

                {/* NCCC */}
                <div className="alignment-section">
                    <div className="alignment-logo-wrapper">
                        <img
                            src="/images/logos/NCCC.jpg"
                            alt="NCCC Logo"
                            className="alignment-logo"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.parentElement.innerHTML = '<div class="alignment-logo-placeholder">🏛️</div>';
                            }}
                        />
                    </div>
                    <div className="alignment-content">
                        <h3>AICIS 2026 AND NCCC OBJECTIVES</h3>
                        <p>
                            The National Council on Climate Change (NCCC) is committed to driving Nigeria's transition towards a
                            low-carbon, climate-resilient economy through strategic policy formulation, climate governance, and
                            sustainable development initiatives. AICIS 2026 aligns with these objectives by serving as a high-level
                            platform for policymakers, industry leaders, and stakeholders to engage in meaningful dialogue and
                            partnerships that advance national climate action.
                        </p>
                        <p>
                            The summit reinforces the NCCC's mandate by promoting renewable energy deployment, climate finance mobilization,
                            and green infrastructure investment—critical components of Nigeria's strategy to reduce greenhouse gas emissions
                            and enhance climate adaptation. Furthermore, AICIS 2026 emphasizes capacity building and private sector engagement,
                            ensuring that local enterprises, innovators, and communities are integral to the nation's sustainable economic
                            growth. Through these efforts, AICIS 2026 contributes to Nigeria's commitment to achieving its Nationally
                            Determined Contributions (NDCs) and long-term climate resilience objectives.
                        </p>
                    </div>
                </div>

                {/* Back Button */}
                <div className="activity-back">
                    <Link to="/activities" className="back-button">← Back to Activities</Link>
                </div>
            </div>
        </div>
    );
};

export default StrategicAlignment;